<template>
  <div v-if="tabList.length > 0">
    <!-- Header -->
    <div class="mb-6">
      <div
        style="
          font-size: 30px;
          font-weight: 800;
          color: #111827;
          letter-spacing: -0.5px;
          line-height: 1.2;
        "
      >
        Assessment &amp; Form Management
      </div>
      <div class="mt-1" style="font-size: 14px; color: #6b7280">
        Manage skills assessment questions, student profiling forms, and view
        results
      </div>
    </div>

    <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left" class="mb-1">
      <v-tab
        value="Skill Assessment"
        @click="changeTab({ id: 1, name: 'Skill Assessment' })"
      >
        <v-icon size="16" class="mr-1">mdi-file-document-outline</v-icon>
        Skills Assessment
      </v-tab>
      <v-tab
        value="Profiling Form"
        @click="changeTab({ id: 2, name: 'Profiling Form' })"
      >
        <v-icon size="16" class="mr-1">mdi-account-circle-outline</v-icon>
        Profiling Form
      </v-tab>
      <v-tab
        value="Student Result"
        @click="changeTab({ id: 3, name: 'Student Result' })"
      >
        <v-icon size="16" class="mr-1">mdi-clipboard-list-outline</v-icon>
        Student Results
      </v-tab>
    </v-tabs>
    <v-divider class="mb-6" />

    <v-col cols="12" v-if="tab == 1">
      <div
        class="d-flex justify-space-between align-center mb-5"
        v-if="tab == 1 && !expandTab1"
      >
        <div style="font-size: 16px; font-weight: 700; color: #111827">
          Question Banks by Batch
        </div>
        <v-btn
          color="#00A63E"
          variant="flat"
          class="text-white"
          @click="add_batch"
          prepend-icon="mdi-plus"
          rounded="lg"
          size="large"
        >
          New Batch
        </v-btn>
      </div>

      <div>
        <v-row v-if="tab == 1 && !expandTab1">
          <v-col cols="6" v-for="(i, idx) in batchData" :key="i.id">
            <v-card class="batch-card rounded-xl" hover @click="openGroup(i)">
              <v-card-text class="pa-6">
                <div class="batch-icon-box rounded-lg mb-4">
                  <v-icon color="#00a63e" size="20">mdi-folder-open</v-icon>
                </div>
                <div class="batch-title mb-2">{{ i.name }}</div>
                <div class="batch-desc mb-4">{{ batchDescSA(i, idx) }}</div>
                <v-divider class="mb-4" />
                <div class="d-flex align-center batch-meta" style="gap: 16px">
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-calendar-outline</v-icon
                    >
                    <span>{{ i.year }}</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-format-list-bulleted</v-icon
                    >
                    <span>{{ i.q_count }} Questions</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 1 && expandTab1">
          <v-col cols="12" style="background-color: white; height: 80vh">
            <div>
              <div
                @click="expandTab1 = !expandTab1"
                color="text-grey "
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>

              <div
                style="
                  background-color: #f0fdf4;
                  border: 1px solid #d1fae5;
                  border-radius: 12px;
                "
                class="my-4 pa-4 d-flex justify-space-between"
              >
                <div>
                  <div class="text-h5 font-weight-bold">
                    {{ q_bank_data.name }}
                  </div>
                </div>
                <div class="d-flex pa-2 align-center">
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-calendar</v-icon>&nbsp;&nbsp; Year
                    {{ q_bank_data.year }}
                  </div>
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-menu</v-icon>&nbsp;&nbsp; Total Questions
                    {{ q_bank_data.q_count }}
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="d-flex justify-space-between align-center mb-3">
                  <div
                    class="text-subtitle-1 font-weight-bold"
                    style="color: #111827"
                  >
                    Manage Skill Assessment Questions
                  </div>
                  <v-btn
                    class="text-white"
                    color="#10b981"
                    @click="addnew"
                    rounded
                    size="small"
                    prepend-icon="mdi-plus"
                  >
                    Add New
                  </v-btn>
                </div>

                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    max-height: 420px;
                    overflow-y: auto;
                    padding: 4px 2px;
                  "
                >
                  <div
                    v-for="i in skill_assessment_list"
                    :key="i.id"
                    style="
                      width: 200px;
                      height: 70px;
                      flex-shrink: 0;
                      border: 1px solid #e5e7eb;
                      border-radius: 10px;
                      background: #ffffff;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      padding: 0 10px 0 14px;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
                      transition: box-shadow 0.2s;
                    "
                    class="sa-card"
                  >
                    <div
                      style="
                        font-size: 12.5px;
                        font-weight: 600;
                        color: #111827;
                        line-height: 1.4;
                        flex: 1;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                      "
                    >
                      {{ i.title }}
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                        margin-left: 6px;
                        flex-shrink: 0;
                      "
                    >
                      <v-btn
                        @click="editItem(i)"
                        icon
                        color="#6b7280"
                        size="x-small"
                        variant="text"
                      >
                        <v-icon size="15">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        @click="deleteItem(i)"
                        icon
                        color="#6b7280"
                        size="x-small"
                        variant="text"
                      >
                        <v-icon size="15">mdi-trash-can</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="mt-2">
                <div class="text-h5 font-weight-bold">
                  Manage Skill Assessment Questions
                </div>
                <v-divider></v-divider>
                <div class="mt-4">
                  <div class="d-flex">
                    <v-btn
                      class="text-white mx-2"
                      color="#10b981"
                      @click="addnew"
                      rounded
                      size="small"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>

                <div class="mt-4">
                  <v-row>
                    <v-col
                      cols="3"
                      v-for="i in skill_assessment_list"
                      :key="i.id"
                    >
                      <div
                        class="pa-2 rounded-lg border border-1 d-flex justify-space-between align-center"
                      >
                        <div>{{ i.title }}</div>
                        <div class="d-flex align-center">
                          <v-btn
                            @click="editItem(i)"
                            icon
                            color="grey"
                            size="small"
                            variant="text"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            @click="deleteItem(i)"
                            icon
                            color="grey"
                            size="small"
                            variant="text"
                          >
                            <v-icon>mdi-trash-can</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <v-col cols="12" v-if="tab == 2">
      <div
        class="d-flex justify-space-between align-center mb-5"
        v-if="tab == 2 && !expandTab2"
      >
        <div style="font-size: 16px; font-weight: 700; color: #111827">
          Profiling Forms by Batch
        </div>
      </div>

      <div>
        <v-row v-if="tab == 2 && !expandTab2">
          <v-col cols="6" v-for="(i, idx) in batchData" :key="i.id">
            <v-card class="batch-card rounded-xl" hover @click="openGroup2(i)">
              <v-card-text class="pa-6">
                <div class="batch-icon-box rounded-lg mb-4">
                  <v-icon color="#00a63e" size="20">mdi-folder-open</v-icon>
                </div>
                <div class="batch-title mb-2">{{ i.name }}</div>
                <div class="batch-desc mb-4">{{ batchDescPF(i, idx) }}</div>
                <v-divider class="mb-4" />
                <div class="d-flex align-center batch-meta" style="gap: 16px">
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-calendar-outline</v-icon
                    >
                    <span>{{ i.year }}</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-format-list-bulleted</v-icon
                    >
                    <span>{{ i._count }} Fields</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 2 && expandTab2">
          <v-col cols="12" style="background-color: white; height: 80vh">
            <div>
              <div
                @click="expandTab2 = !expandTab2"
                color="text-grey "
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>

              <div
                style="
                  background-color: #f0fdf4;
                  border: 1px solid #d1fae5;
                  border-radius: 12px;
                "
                class="my-4 pa-4 d-flex justify-space-between"
              >
                <div>
                  <div class="text-h5 font-weight-bold">
                    {{ batchItem.name }}
                  </div>
                </div>
                <div class="d-flex pa-2 align-center">
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-calendar</v-icon>&nbsp;&nbsp; Year
                    {{ batchItem.year }}
                  </div>
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-menu</v-icon>&nbsp;&nbsp; Added Fields
                    {{ batchItem._count }}
                  </div>
                </div>
              </div>

              <div
                class="mt-2 pa-4"
                style="max-height: 580px; overflow: hidden; overflow-y: auto"
              >
                <div class="text-h5 font-weight-bold">
                  Configure Profiling Form
                </div>
                <v-divider></v-divider>
                <div class="mt-4 mb-2">
                  <div class="d-flex justify-space-between align-center">
                    <div class="font-weight-bold text-subtitle-1">
                      Added Form Fields
                    </div>
                    <v-btn
                      class="text-white mx-2"
                      color="#10b981"
                      @click="addfield"
                      rounded
                      size="small"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>
                <hr />
                <div
                  class="mt-4 px-2 py-6"
                  style="
                    max-height: 500px;
                    overflow-y: auto;
                    overflow-x: hidden;
                  "
                >
                  <v-row>
                    <!-- <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          First Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          First Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Middle Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Middle Name
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Last Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Last Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Suffix
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Suffix
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Program
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Program
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Preferred Training Mode
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Preferred Training Mode
                        </div>
                      </div>
                    </v-col> -->
                    <v-col cols="12" v-for="i in added_fields" :key="i.id">
                      <div class="rounded-lg border border-1 py-2">
                        <div class="d-flex justify-space-between align-center">
                          <div
                            class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                          >
                            {{ i.field_name }}
                          </div>
                          <div class="d-flex align-center">
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="editField(i)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="removeField(i)"
                            >
                              <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <hr />
                        <div
                          v-if="
                            i.field_type == 'Textfield' ||
                            i.field_type == 'Textarea'
                          "
                          class="text-caption pa-2"
                        >
                          <v-text-field
                            v-if="i.field_type == 'Textfield'"
                            hide-details
                            :label="i.field_name"
                            readonly
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                          <v-textarea
                            v-if="i.field_type == 'Textarea'"
                            hide-details
                            :label="i.field_name"
                            readonly
                            rows="3"
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                          ></v-textarea>
                        </div>

                        <div
                          v-if="i.field_type == 'Radio Button'"
                          class="text-caption"
                        >
                          <v-radio-group inline>
                            <v-radio
                              v-for="(j, index) in i.field_options"
                              :key="index"
                              :label="j.option_name"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                        <div
                          v-if="i.field_type == 'Dropdown'"
                          class="text-caption pa-1"
                        >
                          <v-autocomplete
                            dense
                            hide-details
                            :label="i.field_name"
                            class="rounded-lg"
                            item-value="option_name"
                            item-title="option_name"
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                            :items="i.field_options"
                          >
                          </v-autocomplete>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <v-col cols="12" v-if="tab == 3">
      <div
        class="d-flex justify-space-between align-center mb-5"
        v-if="tab == 3 && !expandTab3"
      >
        <div style="font-size: 16px; font-weight: 700; color: #111827">
          Students by Batch
        </div>
      </div>

      <div>
        <v-row v-if="tab == 3 && !expandTab3">
          <v-col cols="6" v-for="(i, idx) in batchData" :key="i.id">
            <v-card class="batch-card rounded-xl" hover @click="openGroup3(i)">
              <v-card-text class="pa-6">
                <div class="batch-icon-box rounded-lg mb-4">
                  <v-icon color="#00a63e" size="20">mdi-folder-open</v-icon>
                </div>
                <div class="batch-title mb-2">{{ i.name }}</div>
                <div class="batch-desc mb-4">{{ batchDescSR(i, idx) }}</div>
                <v-divider class="mb-4" />
                <div class="d-flex align-center batch-meta" style="gap: 16px">
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-calendar-outline</v-icon
                    >
                    <span>{{ i.year }}</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-account-multiple-outline</v-icon
                    >
                    <span>{{ i._count }} Students</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 3 && expandTab3">
          <v-col cols="12" style="background-color: white; height: 80vh">
            <div>
              <div
                @click="expandTab3 = !expandTab3"
                color="text-grey "
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>

              <div
                style="
                  background-color: #f0fdf4;
                  border: 1px solid #d1fae5;
                  border-radius: 12px;
                "
                class="my-4 pa-4 d-flex justify-space-between"
              >
                <div>
                  <div class="text-h5 font-weight-bold">
                    {{ batchItem.name }}
                  </div>
                </div>
                <div class="d-flex pa-2 align-center">
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-calendar</v-icon>&nbsp;&nbsp; Year
                    {{ batchItem.year }}
                  </div>
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-menu</v-icon>&nbsp;&nbsp; Students
                    {{ batchItem._count }}
                  </div>
                </div>
              </div>

              <v-card
                flat
                class="rounded-xl"
                style="
                  overflow-y: auto;
                  max-height: 500px;
                  border: 1px solid #d1d5db;
                  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
                "
              >
                <v-data-table
                  :headers="headers"
                  :items="studentList"
                  :search="search"
                  hover
                  density="compact"
                  class="rounded-lg"
                  show-expand
                >
                  <template
                    v-slot:[`item.data-table-expand`]="{
                      internalItem,
                      isExpanded,
                      toggleExpand,
                    }"
                  >
                    <v-btn
                      :append-icon="
                        isExpanded(internalItem)
                          ? 'mdi-chevron-up'
                          : 'mdi-chevron-down'
                      "
                      :text="isExpanded(internalItem) ? 'Collapse' : 'Details'"
                      class="text-none"
                      color="medium-emphasis"
                      size="small"
                      variant="text"
                      width="105"
                      border
                      slim
                      @click="toggleExpand(internalItem)"
                    ></v-btn>
                  </template>

                  <template v-slot:expanded-row="{ columns, item }">
                    <tr>
                      <td :colspan="columns.length" class="py-2">
                        <div class="pa-2 rounded-lg border border-1">
                          <v-row>
                            <v-col
                              cols="3"
                              v-for="(i, idx) in item.skill_assessment.data"
                              :key="idx"
                            >
                              <div
                                class="pa-2 border border-1 rounded-lg text-caption"
                                :class="
                                  i.isAnswered
                                    ? 'bg-green text-white'
                                    : 'text-grey'
                                "
                              >
                                <div>Title: {{ i.title }}</div>
                                <div v-if="i.score">
                                  Score: {{ i.score + "/" + i.num_items }}
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:[`item.program_tied`]="{ item }">
                    <div v-for="(it, i) in item.programName" :key="i">
                      {{ it.name }}
                    </div>
                  </template>
                  <template v-slot:[`item.assessment_taken`]="{ item }">
                    <div class="text-caption" style="color: #00a63e">
                      {{
                        item.skill_assessment.total_answered +
                        "/" +
                        item.skill_assessment.data.length
                      }}
                    </div>
                  </template>

                  <!-- <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      color="#00a63e"
                      variant="text"
                      size="small"
                      @click="viewStudentItem(item)"
                    >
                      Details
                    </v-btn>
                  </template> -->

                  <template #no-data>
                    <i>No data found.</i>
                  </template>
                </v-data-table>
              </v-card>

              <!-- <div class="mt-2">
                <div class="text-h5 font-weight-bold">
                  Configure Profiling Form
                </div>
                <v-divider></v-divider>
                <div class="mt-4">
                  <div class="d-flex justify-space-between align-center">
                    <div class="font-weight-bold text-subtitle-1">
                      Form Fields
                    </div>
                    <v-btn
                      class="text-white mx-2"
                      color="#10b981"
                      @click="addfield"
                      rounded
                      size="small"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>

                <div class="mt-4">
                  <v-row>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          First Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          First Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Middle Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Middle Name
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Last Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Last Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Suffix
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Suffix
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Program
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Program
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Preferred Training Mode
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Preferred Training Mode
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6" v-for="i in added_fields" :key="i.id">
                      <div class="rounded-lg border border-1">
                        <div class="d-flex justify-space-between align-center">
                          <div
                            class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                          >
                            {{ i.field_name }}
                          </div>
                          <div class="d-flex align-center">
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="editField(i)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="removeField(i)"
                            >
                              <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          {{ i.field_name }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <!-- Data Table -->
    <!-- <v-card elevation="2" class="pa-2" >
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        density="compact"
        class="rounded-lg"
      >
        <template v-slot:[`item.program_tied`]="{ item }">
          <div v-for="(it, i) in item.programName" :key="i">{{ it.name }}</div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          
          <v-tooltip text="Edit" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="warning"
                variant="text"
                v-bind="props"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-tooltip>

        </template>

        <template #no-data>
          <i>No data found.</i>
        </template>
      </v-data-table>
    </v-card> -->

    <!-- Dialogs -->
    <SkillAssessmentDialog
      :data="itemData"
      :action="action"
      :programs="programs_for"
    />

    <SkillAssessmentBatchDialog
      :data="group_data"
      :action="action"
      :batchToAdd="tab"
    />

    <AddProfilingFieldDialog :data="fieldData" :action="action" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import SkillAssessmentDialog from "../Dialogs/Forms/SkillAssessment/SkillAssessmentDialog.vue";
import SkillAssessmentBatchDialog from "../Dialogs/Forms/SkillAssessment/SkillAssessmentBatchDialog.vue";
import AddProfilingFieldDialog from "../Dialogs/Forms/AddProfilingFieldDialog.vue";

export default {
  components: {
    SkillAssessmentDialog,
    SkillAssessmentBatchDialog,
    AddProfilingFieldDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    headers: [
      { title: "Student", value: "name", align: "start" },
      { title: "Program", value: "pg_name", align: "start" },
      {
        title: "Assessments Taken",
        value: "assessment_taken",
        align: "center",
      },

      // {
      //   title: "Actions",
      //   value: "actions",
      //   align: "center",
      //   sortable: false,
      //   width: 200,
      // },
    ],
    data: [],
    activeTab: "Skill Assessment",
    tab: 1,
    tabList: [
      { id: 1, name: "Skill Assessment" },
      { id: 2, name: "Profiling Form" },
      { id: 3, name: "Student Result" },
    ],
    programs_for: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    q_bank_data: null,
    skill_assessment_list: [],
    added_fields: [],
    batchItem: null,
    totalCount: 0,
    group_data: null,
    deleteData: null,
    batchData: null,
    fieldData: null,
    studentList: [],
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    creds: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.getProgramsHandled();
    // this.initialize();

    eventBus.on("closeSkillAssessmentDialog", () => {
      this.loadSAS();
    });
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      this.initialize();
    });
    eventBus.on("closeAddProfilingFieldDialog", () => {
      this.loadAddedFields();
    });
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentDialog");
    eventBus.off("closeSkillAssessmentBatchDialog");
    eventBus.off("closeAddProfilingFieldDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      // this.loading = true;

      if (this.tab == 1) {
        this.axiosCall("/skill-assessement/get-batch/", "GET").then((res) => {
          if (res) {
            console.log("Bacthers", res.data);
            this.batchData = res.data;
            this.loading = false;
          }
        });
      } else if (this.tab == 2) {
        this.axiosCall("/student/get-batches", "GET").then((res) => {
          if (res) {
            console.log(res.data);
            this.batchData = res.data;
            this.loading = false;
          }
        });
      } else if (this.tab == 3) {
        this.axiosCall("/student/get-batches-for-students", "GET").then(
          (res) => {
            if (res) {
              console.log(res.data);
              this.batchData = res.data;
              this.loading = false;
            }
          },
        );
      }
    },

    changeTab(tab) {
      // this.activeTab = tab.abbr;
      // this.tab = tab.program_id;
      this.activeTab = tab.name;
      this.tab = tab.id;

      this.expandTab1 = false;

      this.expandTab2 = false;

      this.expandTab3 = false;

      this.initialize();
    },

    openGroup(item) {
      this.skill_assessment_list = [];
      this.expandTab1 = true;
      this.q_bank_data = item;
      this.loadSAS();
    },

    openGroup2(item) {
      this.expandTab2 = true;
      this.batchItem = item;
      this.loadAddedFields();
    },

    openGroup3(item) {
      this.expandTab3 = true;
      this.batchItem = item;
      this.loadStudents();
    },

    loadSAS() {
      this.axiosCall(
        "/skill-assessement/getSAByGroupId/" + this.q_bank_data.id,
        "GET",
      ).then((res) => {
        if (res) {
          this.skill_assessment_list = res.data;
        }
      });
    },

    loadAddedFields() {
      this.axiosCall(
        "/student/getAddedFieldsByBatch/" + this.batchItem.id,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("FIELDs", res.data);
          this.added_fields = res.data;
        }
      });
    },

    loadStudents() {
      this.axiosCall(
        "/student/getAllStudentsByBatch/" + this.batchItem.id,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("STUDNETDS", res.data);
          this.studentList = res.data;
        }
      });
    },

    getProgramsHandled() {
      this.axiosCall("/program/getProgramsHandled", "GET").then((res) => {
        if (res) {
          console.log("Prog", res.data);
          this.programs_for = res.data;
          // this.activeTab = res.data[0].abbr;
          // this.tabList = res.data;
          // this.tab = res.data[0].program_id;
          console.log(this.tabList);
          this.initialize();
        }
      });
    },
    addnew() {
      this.itemData = {
        id: null,
        skill_assessment_group_id: this.q_bank_data.id,
      };
      this.action = "Add";
    },

    addfield() {
      console.log("Bathid", this.batchItem);
      this.fieldData = {
        id: null,
        student_batch_id: this.batchItem.id,
      };
      this.action = "Add";
    },

    editField(item) {
      console.log("Bathid", this.batchItem);
      this.fieldData = item;
      this.action = "Update";
    },

    removeField(item) {
      let confirm = window.confirm(
        "Are you sure you want to delete this field?",
      );
      if (confirm) {
        this.axiosCall(
          "/student/remove_added_field/" + item.id,
          "DELETE",
          {},
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.loadAddedFields();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    batchDescSA(item, idx) {
      return idx === 0
        ? `Standard assessment and profiling for the ${item.year} internship program.`
        : `Archived assessment questions and forms from previous year.`;
    },
    batchDescPF(item, idx) {
      return idx === 0
        ? `Active profiling form configuration for the ${item.year} batch.`
        : `Archived profiling form fields from the ${item.year} batch.`;
    },
    batchDescSR(item, idx) {
      return idx === 0
        ? `View student assessment results for the ${item.year} internship batch.`
        : `Historical student results from the ${item.year} internship batch.`;
    },
    add_batch() {
      this.group_data = { id: null };
      this.action = "Add";
    },
    deleteItem(item) {
      let confirm = window.confirm(
        "Are you sure you want to delete this item and its contents?",
      );
      if (confirm) {
        this.axiosCall("/skill-assessement/removeSA", "POST", {
          skill_assessment_ids: JSON.stringify(item.skill_assessment_ids),
        }).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.loadSAS();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.batch-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06) !important;
  transition: box-shadow 0.2s;
  cursor: pointer;
}
.batch-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09) !important;
}
.batch-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #dcfce7;
}
.batch-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}
.batch-desc {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}
.batch-meta {
  font-size: 12.5px;
  color: #6b7280;
}
.sa-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  border-color: #10b981 !important;
}
</style>
